// 统一的请求封装。服务端错误 { error } 里的文案可以直接展示给用户。

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init?: { method?: string; body?: unknown }): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: init?.method ?? (init?.body !== undefined ? 'POST' : 'GET'),
      headers: init?.body !== undefined ? { 'content-type': 'application/json' } : undefined,
      body: init?.body !== undefined ? JSON.stringify(init.body) : undefined,
      credentials: 'same-origin',
    });
  } catch {
    throw new ApiError(0, '网络连接断了，联网后会自动重试');
  }
  if (res.status === 401) {
    if (!location.pathname.startsWith('/login')) location.assign(`/login?next=${encodeURIComponent(location.pathname)}`);
    throw new ApiError(401, '请先登录');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, (data as { error?: string }).error ?? '请求没有成功，请稍后再试');
  return data as T;
}

export const post = <T = { ok: true }>(path: string, body: unknown = {}) => api<T>(path, { method: 'POST', body: body ?? {} });
export const patch = <T = { ok: true }>(path: string, body: unknown) => api<T>(path, { method: 'PATCH', body });
export const put = <T = { ok: true }>(path: string, body: unknown) => api<T>(path, { method: 'PUT', body });
export const del = <T = { ok: true }>(path: string) => api<T>(path, { method: 'DELETE' });

export function errorText(e: unknown): string {
  return e instanceof Error ? e.message : '出了点问题，请稍后再试';
}
